import React from 'react'
import { Helmet } from 'react-helmet'
import Breadcrumb from '../components/Breadcrumb'
import ServicesMarquee from '../components/ServicesMarquee'
import ServicesNav from '../components/ServicesNav'
import ServiceGallery from '../components/ServiceGallery'
import { Link } from 'react-router'
const DigitalMarketing = () => {
  return (
    <>
    <Helmet>
      <title>Digital Marketing Services - Om Softwares | SEO, PPC & Content Marketing</title>
      <meta name="description" content="Transform your business with Om Softwares' digital marketing services. From SEO and PPC to content marketing and analytics, we craft data-driven strategies for measurable growth." />
      <meta property="og:title" content="Digital Marketing Services - Om Softwares" />
      <meta property="og:description" content="SEO, PPC, content marketing, and analytics-driven strategies for measurable business growth." />
      <meta property="og:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
      <meta property="og:url" content="https://omsoftwares.in/digital-marketing" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Digital Marketing Services - Om Softwares" />
      <meta name="twitter:description" content="SEO, PPC, content marketing, and analytics-driven strategies for measurable business growth." />
      <meta name="twitter:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
    </Helmet>
    <main>
        <Breadcrumb name="Digital Marketing"/>
        <div className="service-details pt-125 ">
            <div className="container">
                <div className="row mt-none-30 align-items-center">
                    <div className="col-lg-6 mt-30">
                        <div className="section-title">
                            <span className="sub-title wow fadeInRight" data-wow-duration=".7s">Om Softwares - Best Digital Marketing Agency</span>
                            <h3 className="title xb-split-text split-in-right mb-15">Marketing Made Smarter <span>with Om Softwares</span></h3>
                        </div>
                        <div className="service-single-content">
                            <p className="mb-40 wow fadeInUp" data-wow-duration=".7s">
                                At Om Softwares, we transform digital marketing into a powerful tool to drive smarter business growth. Our strategies are tailored to your unique goals, combining creativity and data to deliver exceptional results.
                            </p>
                            <p className="wow fadeInUp" data-wow-delay="200ms" data-wow-duration=".7s">
                                From SEO to social media, we craft campaigns that connect with your audience, boost engagement, and maximize ROI. With Om Softwares, marketing isn’t just smarter—it’s transformative.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-6 mt-30">
                        <div className="service-details_image">
                            <img className="ukiyo" data-u-speed="1.2" src="assets/img/about/digital-marketing-hero.webp" alt="Om Softwares Digital Marketing Services"/>
                        </div>
                    </div>
                </div>
                <div className="row pt-80">
                    <div className="col-lg-8">
                        <div className="sv-details mt-30">
                            <h3 className="sv-title">Effective digital marketing connects your brand with the right audience, <br/> driving engagement and measurable growth <br/> without overwhelming users.</h3>
                            <ul className="sv-list">
                                <li>Strategic social media campaigns</li>
                                <li>Content creation optimized for search engines</li>
                                <li>Targeted ads designed to convert leads into loyal customers</li>
                                <li>Comprehensive analytics to measure success and refine strategies</li>
                            </ul>
                        </div>
                    </div>
                    
                    <div className="col-lg-4 mt-30">
                        <div className="sd-details">
                            <h3 className="sd-title">WHATSAPP API</h3>
                            <p className="sd-content pb-60">Leverage the power of WhatsApp API to streamline communication with your audience through bulk messaging, automated bot replies, and seamless interaction on WhatsApp.</p>
                            <Link to="/contact" className="sd-button">Let’s Talk <img src="assets/img/icon/SD-01.svg" alt=""/></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     
        <section className="service_details-slider z-3 pt-130">
                   
        <ServiceGallery img1="assets/img/searvice/sg_01.jpg" img2="assets/img/searvice/sg_02.jpg"
                        img3="assets/img/searvice/sg_03.jpg" img4="assets/img/searvice/sg_04.jpg"
                        img5="assets/img/searvice/sg_05.jpg" img6="assets/img/searvice/sg_01.jpg"/>
            <div className="container">
                <h3 className="sd-contents pt-125">Effective digital marketing connects your brand with the right audience & <br/> drives engagement without overwhelming them. Bonus points for when it also <br/> delivers measurable results & resonates with your audience!</h3>

            </div>
        </section>
        <ServicesMarquee/>
        <ServicesNav prev="SOCIAL MEDIA MANAGEMENT" next="VISUAL BRANDING"/>
    </main>
    </>
  )
}

export default DigitalMarketing
